export function HeroSection({ product, onLearnMore }) {
  return (
    <section className="hero">
      <div className="hero-copy">
        <p className="eyebrow">REMOTE SMB FILE ACCESS</p>
        <h1>{product.tagline}</h1>
        <p className="hero-description">{product.description}</p>
        <div className="hero-actions">
          <button className="primary-action" type="button" onClick={onLearnMore}>
            NASLinkについて
          </button>
          <span className="platform-label">iOS / Android</span>
        </div>
      </div>

      <div className="hero-visual" aria-label="NASLinkの接続イメージ">
        <div className="connection-line" />
        <div className="device-card device-card--nas">
          <span className="device-label">YOUR NAS</span>
          <strong>SMB</strong>
          <span className="status-dot">Online</span>
        </div>
        <div className="device-card device-card--phone">
          <span className="phone-speaker" />
          <span className="device-label">NASLink</span>
          <strong>Files</strong>
          <span className="file-row" />
          <span className="file-row file-row--short" />
        </div>
      </div>
    </section>
  );
}
